var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "experience" },
    [
      _c("h3", { staticClass: "mb-8" }, [
        _vm._v("Métiers occupés ou en préparation :"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center gap-3 mb-8" },
        [
          _vm.canUpdate()
            ? _c(
                "vs-button",
                {
                  attrs: {
                    id: "addTraining",
                    color: "primary",
                    type: "filled",
                    "icon-pack": "feather",
                    icon: "icon-plus",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createResource()
                    },
                  },
                },
                [_vm._v("\n            Ajouter un métier\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEvaluable.length &&
          _vm.canUpdate() &&
          _vm.planAllow("eval-tiers-croise")
            ? _c(
                "vs-button",
                {
                  attrs: {
                    id: "inviteTiers",
                    color: "primary",
                    type: "border",
                  },
                  on: { click: _vm.inviteTiers },
                },
                [_vm._v("\n            Inviter un tiers à évaluer\n        ")]
              )
            : !_vm.planAllow("eval-tiers-croise") && !_vm.shouldHideOptions()
            ? _c(
                "div",
                {
                  attrs: {
                    title: "Votre formule n'inclut pas cette fonctionnalité",
                  },
                },
                [
                  _c(
                    "vs-button",
                    {
                      attrs: {
                        id: "inviteTiers",
                        color: "primary",
                        type: "border",
                        disabled: "true",
                      },
                    },
                    [
                      _vm._v(
                        "\n                Inviter un tiers à évaluer\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-icon",
                    {
                      staticClass: "button-bullet",
                      attrs: { bg: "#FF9B3A", round: "" },
                    },
                    [
                      _c("CrownIcon", {
                        staticStyle: {
                          width: "16px",
                          height: "16px",
                          padding: "3px",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("feather-icon", {
            staticClass: "option cursor-pointer opaver",
            attrs: { icon: "SettingsIcon" },
            on: {
              click: function ($event) {
                _vm.showOptions = true
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "DialogPrompt",
        {
          attrs: {
            active: _vm.showOptions,
            title: "Ordonner les métiers en cours",
            "cancel-text": "Annuler",
            "accept-text": "Enregistrer",
          },
          on: {
            "update:active": function ($event) {
              _vm.showOptions = $event
            },
            cancel: function ($event) {
              _vm.showOptions = false
            },
            close: function ($event) {
              _vm.showOptions = false
            },
            accept: function ($event) {
              return _vm.closeDialogOrderHandle()
            },
          },
        },
        [
          _c("Draggable", {
            attrs: {
              data: _vm.currentOrderedItems,
              table: {
                columns: [
                  { label: "Ordre", name: "order" },
                  { label: "Nom", name: "title" },
                ],
              },
            },
            on: {
              updated: function ($event) {
                _vm.updatedOrder = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "DialogPrompt",
        {
          attrs: {
            active: _vm.showPopup,
            title: _vm.getDataPrompt.title,
            "cancel-text": "Annuler",
            "accept-text": "Enregistrer",
            "button-accept": _vm.getDataPrompt.btnAccept,
            "is-valid": !_vm.hasError,
          },
          on: {
            "update:active": function ($event) {
              _vm.showPopup = $event
            },
            cancel: _vm.resetResource,
            close: _vm.resetResource,
            accept: _vm.storeResource,
          },
        },
        [
          _c(
            "div",
            { staticClass: "con-exemple-prompt" },
            [
              _c(
                "vs-row",
                { staticClass: "mt-5 mb-8" },
                [
                  _c(
                    "vs-col",
                    [
                      _c(
                        "vs-radio",
                        {
                          attrs: {
                            "vs-value": "0",
                            disabled: this.formType != "create",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.resetResource()
                            },
                          },
                          model: {
                            value: _vm.occupationCategorie,
                            callback: function ($$v) {
                              _vm.occupationCategorie = $$v
                            },
                            expression: "occupationCategorie",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Grille\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-radio",
                        {
                          attrs: {
                            "vs-name": "experienceType",
                            "vs-value": "1",
                            disabled: this.formType != "create",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.resetResource()
                            },
                          },
                          model: {
                            value: _vm.occupationCategorie,
                            callback: function ($$v) {
                              _vm.occupationCategorie = $$v
                            },
                            expression: "occupationCategorie",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Métier Myskilliz\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-radio",
                        {
                          staticClass: "ml-5",
                          attrs: {
                            "vs-name": "experienceType",
                            "vs-value": "2",
                            disabled: this.formType != "create",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.resetResource()
                            },
                          },
                          model: {
                            value: _vm.occupationCategorie,
                            callback: function ($$v) {
                              _vm.occupationCategorie = $$v
                            },
                            expression: "occupationCategorie",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Autre expérience\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.occupationCategorie == _vm.occupationCategories.GRID
                ? _c("div", { staticClass: "vx-row mb-6" }, [
                    _c("div", { staticClass: "vx-col w-full mb-5" }, [
                      _c("b", [_vm._v("Ajouter une grille sur le parcours")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                      _c("span", [_vm._v("Métier* :")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/3 w-full" },
                      [
                        _c(
                          "Multiselect",
                          {
                            attrs: {
                              name: "experienceTypes",
                              options: _vm.grids.data,
                              multiple: false,
                              "group-select": false,
                              placeholder: "Recherche ...",
                              "group-label": "group",
                              "group-values": "items",
                              "track-by": "id",
                              label: "title",
                              "select-label": "",
                              "selected-label": "",
                              "deselect-label": "",
                              loading: _vm.grids.loading,
                            },
                            model: {
                              value: _vm.resource.grid,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource, "grid", $$v)
                              },
                              expression: "resource.grid",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [_vm._v("Aucun résultat.")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              (this.formType == "create" || _vm.resource.occupation) &&
              _vm.occupationCategorie == _vm.occupationCategories.MYSKILLIZ
                ? _c("div", { staticClass: "vx-row mb-6" }, [
                    _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                      _c("span", [_vm._v("Métier déjà existant :")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/3 w-full" },
                      [
                        _vm.occupations.data.length > 0
                          ? _c(
                              "Multiselect",
                              {
                                attrs: {
                                  name: "occupationTitle",
                                  options: _vm.occupations.data,
                                  multiple: false,
                                  "group-label": "group",
                                  "group-values": "items",
                                  placeholder: "Recherche ...",
                                  "track-by": "id",
                                  label: "title",
                                  "select-label": "",
                                  "selected-label": "",
                                  "deselect-label": "",
                                  loading: _vm.occupations.loading,
                                },
                                model: {
                                  value: _vm.resource.occupation,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.resource, "occupation", $$v)
                                  },
                                  expression: "resource.occupation",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("Aucun résultat.")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.occupationCategorie == _vm.occupationCategories.OTHER
                ? _c("div", [
                    _c("div", { staticClass: "vx-row mb-6" }, [
                      _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                        _c("span", [_vm._v("Libellé du métier* :")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-2/3 w-full" },
                        [
                          _c("vs-input", {
                            staticClass: "w-full",
                            attrs: { name: "title" },
                            model: {
                              value: _vm.resource.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource, "title", $$v)
                              },
                              expression: "resource.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Dates :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c("vs-input", {
                      staticClass: "w-full",
                      attrs: {
                        label: "Début*",
                        type: "date",
                        name: "start_date",
                      },
                      model: {
                        value: _vm.resource.start_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "start_date", $$v)
                        },
                        expression: "resource.start_date",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c("vs-input", {
                      staticClass: "w-full",
                      attrs: {
                        label: `Fin${
                          _vm.occupationCategorie ==
                          _vm.occupationCategories.OTHER
                            ? "*"
                            : ""
                        }`,
                        type: "date",
                        name: "end_date",
                      },
                      model: {
                        value: _vm.resource.end_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "end_date", $$v)
                        },
                        expression: "resource.end_date",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "span",
                      { staticStyle: { float: "left", "line-height": "26px" } },
                      [
                        _vm._v(
                          "\n                        Pièce jointe  \n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.documentLicence
                      ? _c("vs-chip", { attrs: { color: "secondary" } }, [
                          _c("b", [
                            _vm._v(
                              "Gratuit jusqu'à " +
                                _vm._s(_vm.postMaxSizePerPerson) +
                                " Mo"
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _vm.resource.doc_path
                      ? [
                          _vm._l(
                            _vm.resource.doc_path.split(";"),
                            function (doc_path, index) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "vx-row mb-3" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inline mr-1 float-left cursor-pointer",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.download(doc_path)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(doc_path.split("/").pop())
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("vs-button", {
                                      staticStyle: {
                                        display: "inline",
                                        "margin-top": "-0.5rem",
                                      },
                                      attrs: {
                                        id: "deleteDoc_Occ_" + doc_path,
                                        color: "primary",
                                        type: "border",
                                        size: "small",
                                        "icon-pack": "feather",
                                        icon: "icon-trash",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeDocPath(
                                            _vm.resource,
                                            doc_path
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            }
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/3 w-full" },
                      [
                        _c("vs-input", {
                          staticClass: "w-full",
                          attrs: {
                            type: "file",
                            multiple: "",
                            accept: _vm.acceptExtensions("all"),
                            name: "doc_path",
                            danger: this.fileError.message,
                            "danger-text": this.fileError.message,
                          },
                          on: { change: _vm.selectFile },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                  _c("span", [_vm._v("Visible dans l'export :")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full mb-2" },
                  [
                    _c("vs-checkbox", {
                      staticClass: "w-full",
                      attrs: { name: "isExportable" },
                      model: {
                        value: _vm.resource.is_exportable,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "is_exportable", $$v)
                        },
                        expression: "resource.is_exportable",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "DialogPrompt",
        {
          attrs: {
            active: _vm.showPopupFullStorage,
            title: "Votre espace de stockage est plein",
            "cancel-text": "Annuler",
            "accept-text": "OK",
          },
          on: {
            "update:active": function ($event) {
              _vm.showPopupFullStorage = $event
            },
            close: function ($event) {
              _vm.showPopupFullStorage = false
            },
            accept: function ($event) {
              _vm.showPopupFullStorage = false
            },
          },
        },
        [
          _c("div", { staticClass: "con-exemple-prompt" }, [
            _c("p", [_vm._v(_vm._s(_vm.popupFullStorageMessage))]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "vs-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            sst: true,
            data: _vm.orderedItems,
            "no-data-text": "Aucune donnée à afficher",
          },
          on: { sort: _vm.eventSortByCol },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (item, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, attrs: { data: item } },
                    [
                      _c("vs-td", { attrs: { data: item.title } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.title) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-td", { attrs: { data: item.start_date } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("date")(item.start_date || "-")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-td", { attrs: { data: item.end_date } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("date")(item.end_date || "-")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      item.doc_path
                        ? _c(
                            "vs-td",
                            [
                              _vm._l(
                                item.doc_path.split(";"),
                                function (doc_path, index) {
                                  return [
                                    doc_path
                                      ? _c("i", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: {
                                                content: doc_path
                                                  .split("/")
                                                  .pop(),
                                                placement: "top-start",
                                                classes: ["occ-description"],
                                              },
                                              expression:
                                                "{\n                                content: doc_path.split('/').pop(),\n                                placement: 'top-start',\n                                classes: ['occ-description']\n                            }",
                                            },
                                          ],
                                          key: "file_" + doc_path + index,
                                          class:
                                            "ml-1 fa fa-file" +
                                            (doc_path.split(".").pop() === "pdf"
                                              ? "-pdf"
                                              : ""),
                                          staticStyle: {
                                            "font-size": "2rem",
                                            color: "rgba(var(--vs-primary),1)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.download(doc_path)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _c("vs-td"),
                      _vm._v(" "),
                      _c(
                        "vs-td",
                        [
                          item.is_exportable
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Export autorisé",
                                    expression: "'Export autorisé'",
                                  },
                                ],
                                staticClass: "ml-2",
                                attrs: {
                                  icon: "CheckSquareIcon",
                                  "svg-classes":
                                    "h-6 w-6 icon-info vs-icon-primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.exportableClickHandle(
                                      item,
                                      false
                                    )
                                  },
                                },
                              })
                            : _c("feather-icon", {
                                staticClass: "ml-2",
                                attrs: {
                                  icon: "SquareIcon",
                                  "svg-classes": "h-6 w-6 icon-info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.exportableClickHandle(item, true)
                                  },
                                },
                              }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.canUpdate()
                        ? _c(
                            "vs-td",
                            [
                              _vm.can("update", "employees")
                                ? _c("vs-button", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Modifier",
                                        expression: "'Modifier'",
                                      },
                                    ],
                                    attrs: {
                                      id: "modifyJob_" + indextr,
                                      color: "primary",
                                      type: "border",
                                      "icon-pack": "feather",
                                      icon: "icon-edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateResource(item)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.can("update", "employees")
                                ? _c("vs-button", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Supprimer",
                                        expression: "'Supprimer'",
                                      },
                                    ],
                                    staticStyle: { "margin-left": "1rem" },
                                    attrs: {
                                      id: "deleteJob_" + indextr,
                                      color: "primary",
                                      type: "border",
                                      "icon-pack": "feather",
                                      icon: "icon-trash",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteResource(item)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "title" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Libellé")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "start_date" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Date de début")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "end_date" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Date de fin")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("vs-th", [_vm._v("\n                Document\n            ")]),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "is_exportable" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Export")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.canUpdate()
                ? _c("vs-th", [
                    _vm._v("\n                Actions\n            "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }